import React from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { BrowserRouter as Router } from "react-router-dom";
import { ThemeProvider } from "@mui/material/styles";

import theme from "./utils/theme";
import Routes from "./routes";
import AppProvider from "./AppProvider";

const App = () => {
  const { isAuthenticated, isLoading, loginWithRedirect } = useAuth0();

  if (isLoading) return <div />;
  if (!isAuthenticated) {
    loginWithRedirect();
    return;
  }

  return (
    <Router>
      <ThemeProvider theme={theme}>
        <AppProvider>
          <Routes />
        </AppProvider>
      </ThemeProvider>
    </Router>
  );
};

export default App;
